<div class="db-one-week-free-demo__option {{activeTab}}" [ngClass]="{'agency': isAgency}">
  <div>
    <div class="db-one-week-free-demo__option-header">
      <h1 *ngIf="title">{{ title }}</h1>
      <p *ngIf="description" [innerHTML]="description"></p>
    </div>
    <div class="db-one-week-free-demo__option-price mt8">
  <!--    <h1>
        <span class="db-one-week-free-demo__option-price-line-through mr8" *ngIf="periodSwitchValue === 12">${{monthlyPrice}}</span>${{
          (subscription?.plan?.planPrice / periodSwitchValue * (100 - couponPercent) / 100) | DbNumberFormatPipe:
            periodSwitchValue === 12 || applyCouponForPlatform ? 'ceil' : 'floor'
        }}<span>/mo</span>
      </h1>-->
      <h1>
        <span class="db-one-week-free-demo__option-price-line-through mr8" *ngIf="periodSwitchValue === 12">${{monthlyPrice}}</span>${{
          (subscription?.plan?.planPrice / periodSwitchValue * (100 - couponPercent) / 100) | DbNumberFormatPipe:
            periodSwitchValue === 12 || applyCouponForPlatform ? 'ceil' : 'floor'
        }}<span>/mo</span>
      </h1>
      <p>Billed
        {{ periodSwitchValue === 12 ? 'annually' : 'monthly' }}</p>

      <a class="ds-btn-purple-blue mt16 ds-btn-l"
         [ngClass]="{'ds-btn-l': !isMobile, 'ds-btn-m': isMobile}"
         (click)="onStepChange.emit('checkout')">
        <span>{{ (paidFeature ? 'Get 10Web Pro plans' : 'Try It Free for 7 Days') | lowerCaseSpecificWords }}</span>
      </a>

    </div>
    <div class="db-one-week-free-demo__plan-info mt26">
      <p *ngFor="let planInfo of plan" >
        <i class="db-icon db-icon-ds-checkmark"></i>
        <span class="ml6"
              [ngClass]="{'with-gradient': ['Free custom domain up to $30', '1 free custom domain up to $30'].includes(planInfo)}"
              [innerHTML]="domainName && ['Free custom domain up to $30', '1 free custom domain up to $30'].includes(planInfo) ? domainName + ' for free' : replaceParam(planInfo, {
                  monthlyVisitors: (subscription?.plan?.services?.hosting?.hosting_visits?.parameter_value | count),
                  ssdStorage: (subscription?.plan?.services?.hosting?.hosting_storage?.parameter_value * 1024 * 1024 | size),
                  aiWebsites: subscription?.plan?.services?.ai_builder?.regeneration_count?.parameter_value,
                  cdnBandwidth: (subscription?.plan?.cdnAdditionalBandwidthValue) | size: {unit: 'MB'},
                  websites: subscription?.plan?.services?.hosting?.domain_count?.parameter_value,
                  period: periodSwitchValue === 12 ? '1 year' : '1 month'
              })"></span>
      </p>
    </div>
  </div>
</div>
